import { Stack, Typography } from "@mui/material";
import { UploadImage } from "Common/Assets";
import React, { useRef, useState } from "react";

interface IDragAndDropArea {
  onFilesDropped?: (files: File[]) => void; // Callback to handle files after drop
}

export const DragAndDropArea: React.FC<IDragAndDropArea> = ({ onFilesDropped }) => {
  const fileInputRef = useRef<HTMLInputElement | null>(null);
  const [isDragOver, setIsDragOver] = useState(false);

  const onDragEnterEventHandler = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(true);
  };

  const onDragOverEventHandler = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const onDragLeaveEventHandler = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);
  };

  const onDropEventHandler = (e: React.DragEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragOver(false);

    const files = Array.from(e.dataTransfer.files);
    if (files.length > 0 && onFilesDropped) {
      onFilesDropped(files);
    }
  };

  const fileChangeEventHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = e.target.files ? Array.from(e.target.files) : [];
    if (files.length > 0 && onFilesDropped) {
      onFilesDropped(files);
    }

    e.target.value = "";
  };

  return (
    <Stack
      onDragEnter={onDragEnterEventHandler}
      onDragOver={onDragOverEventHandler}
      onDrop={onDropEventHandler}
      onDragLeave={onDragLeaveEventHandler}
      spacing={2}
      sx={(theme) => ({
        flex: 1,
        justifyContent: "center",
        alignItems: "center",
        padding: 2,
        border: `1px solid ${theme.palette.grey[400]}`,
        borderRadius: theme.shape.borderRadius,
        backgroundColor: isDragOver ? theme.palette.action.hover : theme.palette.background.paper,
        cursor: "pointer",
        transition: "background-color 0.3s ease",
      })}
      onClick={() => fileInputRef.current?.click()}
    >
      <UploadImage />
      <Typography variant="subtitle1">Drag file(s) to this area to upload</Typography>
      <input multiple type="file" ref={fileInputRef} accept="*" hidden onChange={fileChangeEventHandler} />
    </Stack>
  );
};
